
type Props = {}

export default function TermsAndConditions(_props: Props) {
    return (
        <div>TermsAndConditions</div>
    )
}